import { render } from "./CV.vue?vue&type=template&id=cb600bb2"
import script from "./CV.vue?vue&type=script&lang=js"
export * from "./CV.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__